var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_201_19841)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.3375,
    cy: 30.9996,
    r: 27.9,
    fill: "#8247E5",
    fillOpacity: 0.12
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 25.242C40.1195 24.8374 39.2273 24.8374 38.4724 25.242L33.1188 28.3432L29.4812 30.3658L24.1277 33.467C23.4414 33.8715 22.5491 33.8715 21.7941 33.467L17.5388 31.0399C16.8525 30.6354 16.372 29.8938 16.372 29.0848V24.2981C16.372 23.4891 16.7838 22.7475 17.5388 22.343L21.7255 19.9833C22.4119 19.5788 23.3041 19.5788 24.0591 19.9833L28.2458 22.343C28.9321 22.7475 29.4126 23.4891 29.4126 24.2981V27.3994L33.0502 25.3094V22.2081C33.0502 21.3991 32.6385 20.6575 31.8835 20.253L24.1277 15.8034C23.4414 15.3989 22.5491 15.3989 21.7941 15.8034L13.9012 20.253C13.1462 20.6575 12.7344 21.3991 12.7344 22.2081V31.1748C12.7344 31.9838 13.1462 32.7255 13.9012 33.13L21.7941 37.5796C22.4805 37.9841 23.3727 37.9841 24.1277 37.5796L29.4812 34.5457L33.1188 32.4558L38.4724 29.4219C39.1587 29.0174 40.0509 29.0174 40.8059 29.4219L44.9926 31.7815C45.6789 32.186 46.1594 32.9277 46.1594 33.7367V38.5233C46.1594 39.3325 45.7477 40.074 44.9926 40.4785L40.8059 42.9056C40.1195 43.3101 39.2273 43.3101 38.4724 42.9056L34.2857 40.546C33.5993 40.1415 33.1188 39.3998 33.1188 38.5908V35.4896L29.4812 37.5796V40.6807C29.4812 41.4897 29.8931 42.2314 30.648 42.6359L38.541 47.0855C39.2273 47.49 40.1195 47.49 40.8745 47.0855L48.7676 42.6359C49.4539 42.2314 49.9344 41.4897 49.9344 40.6807V31.7141C49.9344 30.9051 49.5225 30.1636 48.7676 29.7591L40.8059 25.242Z",
    fill: "#8247E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_201_19841",
    x: -34.5625,
    y: -34.9004,
    width: 131.801,
    height: 131.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_19841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_19841",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.e71d842455ab5126d20192c7d455b636.svg";
export { ForwardRef as ReactComponent };